import React from 'react';
import PropTypes from 'prop-types';
import { DthcActions, TextEditor } from '../../../Modules';
import { Grid } from 'semantic-ui-react';
import Formsy from 'formsy-react';

const NotesEditDesktop = ({ closeHandler, commitUpdate, onChange, reset, value }) =>
  <Formsy.Form onSubmit={commitUpdate.bind(null, closeHandler)}>
    <Grid padded relaxed stackable>
      <Grid.Row columns={1}>
        <Grid.Column>
          <TextEditor
            value={value}
            onChange={onChange}
            placeholder='Enter notes or additional details'
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <DthcActions reset={(e) => { reset(); closeHandler(e); e.stopPropagation(); }} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Formsy.Form>;

NotesEditDesktop.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  commitUpdate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default NotesEditDesktop;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Notes/NotesEditDesktop.js